import { render, staticRenderFns } from "./DragZone.vue?vue&type=template&id=94de50dc&scoped=true&lang=pug"
import script from "./DragZone.vue?vue&type=script&lang=js"
export * from "./DragZone.vue?vue&type=script&lang=js"
import style0 from "./DragZone.vue?vue&type=style&index=0&id=94de50dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94de50dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
